import { createContext } from 'react';

import { HistoryContextType } from './types';

const HistoryContext = createContext<HistoryContextType>(({} as unknown) as HistoryContextType);

export default HistoryContext;
